import React from 'react';
import GooglePlayApp from './GooglePlayApp';
import AppleAppStoreApp from './AppleAppStoreApp';
import {Typography} from '@material-ui/core/';

const MobileAppBadges = () => {
    return (
        <div className="container">
            <Typography variant="body1" className='desc-text'>Pobierz naszą aplikacje mobilną QSAFE24
                Mobile:</Typography>
            <div className="appBadges">
                <GooglePlayApp/>
                <AppleAppStoreApp/>
            </div>
        </div>
    );
};

export default MobileAppBadges;
